<template>
  <v-layout column class="fill-viewport">
    <div ref="tabs">
      <v-tabs v-if="ready" v-model="filter" background-color="transparent">
        <v-tab>{{ $t('types.all') }}</v-tab>
        <v-tab v-for="type in types" :key="type">
          {{ $t('types.' + type) }}
        </v-tab>
      </v-tabs>
    </div>
    <v-layout row wrap class="mt-4 listing">
      <v-flex xs12 md5 class="items">
        <h2>{{ $t('select') }}</h2>
        <v-container grid-list-md fluid class="pa-1">
          <v-layout row wrap align-items-start>
            <v-flex xs-4 v-for="item in items" :key="item.id" class="item">
              <v-card flat ripple class="v-btn v-btn--flat pa-2 ma-0"
                :class="{'active': selected === item}"
                @click.native="select(item)"
              >
                <v-img :src="item.img ? require(`../assets/integrations/${item.img}`) : undefined" contain height="60" />
                <v-spacer></v-spacer>
                <v-card-text class="pa-0">
                  <div class="caption text-center">{{ item.name }}</div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs12 md7>
        <div class="sideinfo">
          <iframe v-if="selected" :src="selected.doc"></iframe>
          <div v-else class="empty text-center text-uppercase grey--text">
            <div>{{ $t('empty') }}</div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { delayUntilVisible } from '@/services/utils'
import { types, integrations } from '@/services/integrations'

export default {
  data () {
    return {
      ready: false,
      types,
      items: [],
      selected: null,
      filter: null
    }
  },
  watch: {
    filter (newValue) {
      if (newValue === 0) {
        this.items = integrations
      } else {
        const type = this.types[newValue - 1] // first is 'all'
        this.items = integrations.filter((item) => item.type === type)
      }
    }
  },
  mounted () {
    // the following is required for the tabs slider to display properly
    delayUntilVisible(this.$refs, 'tabs')
      .then(() => { this.ready = true })
      .catch(() => { /* discard: component not active anymore */ })
  },
  methods: {
    select (item) {
      this.selected = this.selected === item ? null : item
    }
  }
}
</script>

<style lang="scss" scoped>
.fill-viewport {
  height: calc(100% - 48px) !important;
  left: 24px;
  position: absolute;
  right: 24px;
  top: 24px;
}

.listing {
  overflow: hidden;
}

::v-deep .v-tabs-slider {
  color: var(--v-accent-base);
}

.items {
  height: 100%;
  overflow: auto;
}

.item {
  flex: 0 0 auto;
  width: 120px;
}

.v-btn {
  border-radius: 3px;
  border: 1px solid var(--v-secondary-lighten4);
  cursor: pointer;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  height: 120px;
  width: auto;

  &.active {
    box-shadow: 0 0 5px 1px var(--v-accent-base);
    color: var(--v-accent-base);
  }

  .v-image {
    width: 100%;
  }

  .caption {
    margin-top: 8px;
  }
}

.sideinfo {
  border: 1px solid var(--v-secondary-base);
  height: 30rem;
  margin: 1rem 0;
}

iframe {
  border: none;
  height: 100%;
  width: 100%;
}

@media (min-width: 960px) {
  .sideinfo {
    height: 100%;
    margin: 0;
  }

  .empty {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
  }
}
</style>

<i18n>
{
  "en": {
    "types": {
      "all": "All",
      "network": "Network",
      "servers": "Servers & Virtualization",
      "storage": "Storage",
      "apps": "Apps & DB",
      "cloud": "Clouds",
      "containers": "Containers",
      "monitoring": "Monitoring",
      "others": "Others"
    },
    "unavailable": "Sorry, this component details are not available yet...",
    "empty": "Please select an item to view its details here",
    "select": "Select the integrations you want to install:"
  }
}
</i18n>
